export { default as CheckCircleSolidIcon } from './CheckCircleSolidIcon';
